import React from "react";
import { Outlet } from "react-router-dom";
import Footer from "./Footer/Footer";
import Header from "./Header/Header";
import Hero from "./Hero/Hero";
import ScrollToTop from "./topScreen";

export default function Layout() {
  return (
    <div>
      <ScrollToTop />
      <Header />
      <Hero />

      <Outlet />
      <Footer />
    </div>
  );
}
